import React, { Suspense, lazy, useEffect, useState, useRef } from 'react'
import { parseSearchQuery, webStorage } from 'sidecar-utility-library'
import { Outlet, useLocation, Navigate } from 'react-router-dom'
import { connect } from 'react-redux'

const AutoLogoutModal = lazy(() => import('components/_common/AutoLogout'))

export const BasePrivateRoutes = ({
  isAuthAttempted,
  timeOutInMinutes,
  token,
}) => {
  const location = useLocation()

  const [possibleImpersonation, setPossibleImpersonation] = useState({})

  // Capture the initial URL on first mount, before any internal redirects
  // This is needed because React Router may execute child route redirects
  // (like "/" -> "/dashboard") before we can capture the intended URL
  const initialUrlRef = useRef(`${location.pathname}${location.search}`)

  const generateIntendedUrl = () => {
    const intendedUrl = initialUrlRef.current
    // Redirect to intended URL if it's not just the root path
    const result =
      intendedUrl !== '/' ? `?next=${encodeURIComponent(intendedUrl)}` : ''
    return result
  }

  useEffect(() => {
    // Check both URL params (for initial load) and webStorage (for subsequent navigation)
    // URL params are cleaned immediately after load, so webStorage is the source of truth
    const { t, a } = parseSearchQuery(location.search)
    const isAdminFromStorage = webStorage.getItem('isAdmin')
    const possibleImpersonationValue =
      !!(a && t) || isAdminFromStorage === 'true'

    setPossibleImpersonation(possibleImpersonationValue)
  }, [location])

  return (
    <Suspense
      fallback={
        <div
          style={{ textAlign: 'center', marginTop: '1.25rem', color: '#888' }}
        >
          Loading ...
        </div>
      }
    >
      {isAuthAttempted && (token || possibleImpersonation) && (
        <>
          <Outlet />
          {!!timeOutInMinutes && <AutoLogoutModal />}
        </>
      )}
      {isAuthAttempted && !token && !possibleImpersonation && (
        <Navigate to={`/login${generateIntendedUrl()}`} replace />
      )}
      {!isAuthAttempted && null}
    </Suspense>
  )
}

const mapStateToProps = ({ App, Auth }) => ({
  isAuthAttempted: Auth.isAuthAttempted,
  timeOutInMinutes: App.timeOutInMinutes ?? 0,
  token: Auth.authToken,
})

export const PrivateRoutes = connect(mapStateToProps)(BasePrivateRoutes)
